import { render, staticRenderFns } from "./form-baseinfo-application.vue?vue&type=template&id=3c3cde5c"
import script from "./form-baseinfo-application.vue?vue&type=script&lang=js"
export * from "./form-baseinfo-application.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports